import ITabMenuContentSection from "./ITabMenuContentSection";
import { ItemType } from "./ITabMenuContentItem";
import { getApiDocSection } from "./IDocSection";

const SMSDocsMenu: Array<ITabMenuContentSection> = [
  {
    title: "Guides",
    items: [
      {
        name: "API",
        type: ItemType.doc,
        href: "/docs?id=sms/guides/api/gettingstarted.html",
        startMatches: ["/docs?id=sms/guides/api/"],
        docSection: {
          section: "API Guides",
          headerMenu: [
            {
              name: "API Guides",
              href: "/docs?id=sms/guides/api/gettingstarted.html",
              alwaysSelected: true,
            },
          ],
        },
      },
      {
        name: "ECommerce",
        type: ItemType.doc,
        href: "/docs?id=sms/guides/ecommerce/index.html",
        startMatches: ["/docs?id=smsdocs/ecommerce/"],
        docSection: {
          section: "ECommerce Guides",
          headerMenu: [
            {
              name: "ECommerce Guides",
              href: "/docs?id=sms/guides/ecommerce/index.html",
              alwaysSelected: true,
            },
          ],
        },
      },
      {
        name: "Single Sign On",
        type: ItemType.doc,
        href: "/docs?id=sms/guides/sso/index.html",
        startMatches: ["/docs?id=sms/guides/sso/"],
        docSection: {
          section: "SSO Guides",
          headerMenu: [
            {
              name: "SSO Guides",
              href: "/docs?id=sms/guides/sso/index.html",
              alwaysSelected: true,
            },
          ],
        },
      },
      {
        name: "SkyBuild",
        type: ItemType.doc,
        href: "/docs?id=sms/guides/SkyBuild/index.html",
        startMatches: ["/docs?id=sms/guides/SkyBuild/"],
        docSection: {
          section: "SkyBuild Guides",
          headerMenu: [
            {
              name: "SkyBuild Guides",
              href: "/docs?id=sms/guides/SkyBuild/index.html",
              alwaysSelected: true,
            },
          ],
        },
      },
    ],
  },
  {
    title: "API",
    items: [
      {
        name: "OneRoster®",
        type: ItemType.api,
        href: "/docs?id=sms/restapi/api/oneroster/index.html",
        startMatches: ["/docs?id=sms/restapi/api/oneroster/", "/try-it-out/sms 2.0/oneroster"],
        docSection: getApiDocSection("API", "SMS 2.0", "sms", "oneroster"),
      },
      {
        name: "LMS",
        type: ItemType.api,
        href: "/docs?id=sms/restapi/api/1/index.html",
        startMatches: ["/docs?id=sms/restapi/api/1/", "/try-it-out/sms 2.0/1"],
        docSection: getApiDocSection("API", "SMS 2.0", "sms", "1"),
      },
    ],
  },
];

export default SMSDocsMenu;
